const fileFragment = `
  id
  file
  fileName
`;

export const listVerificationDocumentsQuery = `
  query ListVerificationDocuments(
    $id: Int!
  ) {
    items: listVerificationDocuments(id: $id) {
      id
      fileName
      fileSize
      fileType
      type
      side
      createdAt
    }
  }
`;

export const downloadOnfidoFileMutation = `
  mutation DownloadOnfidoFile(
    $input: OnfidoFileDownloadInput!
  ) {
    item: downloadOnfidoFile(input: $input) {
      ${fileFragment}
    }
  }
`;

export const downloadPlaidFileMutation = `
  mutation DownloadPlaidFile(
    $input: PlaidFileDownloadInput!
  ) {
    fileUrl: downloadPlaidFile(input: $input)
  }
`;

export const markIdVerificationAsVerifiedMutation = `
  mutation MarkIdVerificationAsVerified(
    $input: MarkIdVerificationAsVerifiedInput!
  ) {
    item: markIdVerificationAsVerified(input: $input) {
      id
    }
  }
`;
